export default __webpack_public_path__ + "static/media/IMG-20240729-WA0009.63c7d008.jpg";